import zod from "zod";
import { fileSchema } from "@/api/http/schemas/fileSchemas";

export const funderSchema = zod.object({
  id: zod.string(),
  full_name: zod.string(),
  description: zod.string().nullable(),
  logo: fileSchema.nullable(),
  website: zod.string().nullable(),
});

export type Funder = zod.infer<typeof funderSchema>;
